export default "__VITE_ASSET__4609027d__"